import {buildCommonEditorActionTypes} from "./commonEditorATBuider";
import {buildCommonGridActionTypes} from "./commonGridATBuilder";


export const NEWS_GRID = buildCommonGridActionTypes('NEWS');

export const NEWS_EDITOR = buildCommonEditorActionTypes('NEWS');

export const EDIT_NEWS_LIST_VIEW_IMAGE = 'LIST_VIEW';
